import client from './client'

const fetchMap = () => {
  return client.get('/items/thjonustukort')
}

export default fetchMap
